var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFdsTokenCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#090C0F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6350_13882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.357 21.3989L20.8107 16L19.4507 20.816L23.357 21.3989Z",
    fill: "#0DC36F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.811 16L17.2544 19.7257L19.451 20.816L20.811 16Z",
    fill: "#10F48B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2543 19.7257L16.5 22.7634L19.4509 20.816L17.2543 19.7257Z",
    fill: "#70F8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4118 25.968L43.5878 38.032L46.2164 33.8377L23.357 21.3989L19.4507 20.816L21.4118 25.968Z",
    fill: "#10F48B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.549 43.184L48.4999 41.2366L46.2165 33.8377L43.5879 38.032L45.549 43.184Z",
    fill: "#70F8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6431 42.6011L44.1894 48L45.5494 43.184L41.6431 42.6011Z",
    fill: "#066238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5493 43.184L47.7459 44.2743L48.5002 41.2366L45.5493 43.184Z",
    fill: "#10F48B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4509 20.816L16.5 22.7634L18.7834 30.1623L21.412 25.968L19.4509 20.816Z",
    fill: "#066238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.189 48L47.7455 44.2743L45.549 43.184L44.189 48Z",
    fill: "#0DC36F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5883 38.032L21.4123 25.968L18.7837 30.1623L41.6431 42.6011L45.5494 43.184L43.5883 38.032Z",
    fill: "#004528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7632 20.1691L47.3666 27.3737V16L44.7632 20.1691Z",
    fill: "#70F8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7631 20.1691L26.4683 16L47.3665 27.3737L44.7631 20.1691Z",
    fill: "#004528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7631 20.1691L47.3665 16H26.4683L44.7631 20.1691Z",
    fill: "#0DC36F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2279 43.8309L17.6245 36.6263V48L20.2279 43.8309Z",
    fill: "#10F48B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2279 43.8309L38.5251 48L17.6245 36.6263L20.2279 43.8309Z",
    fill: "#0A9253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2279 43.8309L17.6245 48H38.5251L20.2279 43.8309Z",
    fill: "#004528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6350_13882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdsTokenCoin);
export default __webpack_public_path__ + "static/media/FDS-Token-Coin.4d70c50b6995115c4bb8e4f80b49aab7.svg";
export { ForwardRef as ReactComponent };